require('styles/stylesGlobal.scss');
const React = require('react');
const TagManager = require('react-gtm-module');
const Layout = require('templates/layout').default;

exports.onClientEntry = async () => {
  if (typeof window !== 'undefined') {
    window.onload = () => {
      const isLighthouse =
        navigator?.userAgent?.indexOf('Chrome-Lighthouse') > -1;
      if (process.env.GATSBY_ISDEVELOPMENT === 'false' && !isLighthouse) {
        const tagManagerArgs = {
          gtmId: process.env.GATSBY_HABI_GTM_ID,
        };
        TagManager.initialize(tagManagerArgs);
      }
    };
  }
  if (typeof IntersectionObserver === 'undefined') {
    await import('intersection-observer');
  }
};

exports.wrapRootElement = ({ element }) => <Layout>{element}</Layout>;
